import { TypedStartListening, combineReducers, configureStore, createListenerMiddleware } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import authSlice from './auth/authSlice'
import bookingCreationSlice from './booking/bookingCreationSlice'
import bookingSlice from './booking/bookingSlice'
import editBookingInfoSlice from './booking/editBookingInfoSlice'
import bookingDetailsSlice from './bookingDetails/bookingDetailsSlice'
import bookingSummarySlice from './bookingSummary/bookingSummarySlice'
import chatSlice from './chat/chatSlice'
import configSlice from './config/configSlice'
import locationsContact from './contact/contactSlice'
import driverSlice from './driver/driverSlice'
import etaSlice from './eta/etaSlice'
import informationSlice from './information/informationSlice'
import locationInfoSlice from './locations/infoLocation'
import locationsSlice from './locations/locationSlice'
import portsSlice from './locations/portsSlice'
import vesselSlice from './locations/vesselSlice'
import makerSlice from './maker/index'
import mapSlice from './map/mapSlice'
import messageErrorSlice from './messageError/messageErrorSlice'
import modalSlice from './modal/modalSlice'
import paymentSlice from './payment/paymentSlice'
import popupContentSlice from './popupContent/popupContentSlice'
import settingSlice from './setting/settingSlice'

const listenerMiddlewareInstance = createListenerMiddleware({
  onError: () => console.error,
})

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  configuration: configSlice.reducer,
  driver: driverSlice.reducer,
  information: informationSlice.reducer,
  modal: modalSlice.reducer,
  mapObject: mapSlice.reducer,
  locations: locationsSlice.reducer,
  ports: portsSlice.reducer,
  vessel: vesselSlice.reducer,
  booking: bookingSlice.reducer,
  bookingCreation: bookingCreationSlice.reducer,
  editBookingInfo: editBookingInfoSlice.reducer,
  locationsContact: locationsContact.reducer,
  infoLocation: locationInfoSlice.reducer,
  bookingDetails: bookingDetailsSlice.reducer,
  makers: makerSlice.reducer,
  etaInfo: etaSlice.reducer,
  setting: settingSlice.reducer,
  paymentInfo: paymentSlice.reducer,
  bookingSummary: bookingSummarySlice.reducer,
  chat: chatSlice.reducer,
  messageError: messageErrorSlice.reducer,
  popupContent: popupContentSlice.reducer,
})

const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
  devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStartListening = TypedStartListening<RootState, AppDispatch>

export const startAppListening = listenerMiddlewareInstance.startListening as AppStartListening
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
